import React from 'react';
import { Button } from '@material-tailwind/react';
import Modal from './Modal';

interface FileTypeErrorModalProps {
  open: boolean;
  onClose: () => void;
  primaryColor?: string;
  supportedTypes?: string[];
  title?: string;
  message?: string;
}

const FileTypeErrorModal: React.FC<FileTypeErrorModalProps> = ({
  open,
  onClose,
  primaryColor = '#002861',
  supportedTypes = ['JPG', 'JPEG', 'PNG', 'PDF'],
  title = 'Oops!',
  message
}) => {
  const defaultMessage = `That file type isn't supported. Please upload your document as a ${supportedTypes
    .slice(0, -1)
    .join(', ')} or ${supportedTypes[
    supportedTypes.length - 1
  ].toUpperCase()}.`;

  return (
    <Modal size="md" open={open} onClose={onClose} hideClose>
      <div className="pt-6 flex flex-col gap-4">
        <h2 className="text-grey-900 font-semibold text-xl">{title}</h2>
        <p className="text-gray-600 text-[14px] leading-relaxed">
          {message || defaultMessage}
        </p>
        <Button
          variant="text"
          className="text-grey-600 w-full border border-grey-300 text-base normal-case rounded font-semibold py-[10px] px-[18px]"
          onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default FileTypeErrorModal;
